import React from 'react';
import { Button } from '@cityelectricalfactors/ui-components';
import styled from 'styled-components';
import CloseXmark from '../../../assets/images/shared/icons/close-xmark.svg';

const VideoClose = ({ onClick }) => {
  return (
    <CloseButton aria-label="close modal" handleClick={onClick}>
      <img
        src={CloseXmark}
        alt=""
        className="video-close__icon"
        width={38}
        height={38}
      />
    </CloseButton>
  );
};

const CloseButton = styled(Button)`
  position: absolute;
  right: -12px;
  top: -16px;
  padding: 0;
  background-color: transparent;
  @media (min-width: 1025px) {
    right: -34px;
    top: -34px;
  }
`;

export default VideoClose;
